/*
 --------------------
 VIDEO PLAYER MANAGER
 --------------------

 Spawns, destroys and stores all video players */
import videoPlayer from './video-player';
import outstreamVideoPlayer from './video-player-outstream';
import audioOnlyPlayer from './video-player-audio-only';

class videoPlayerManager {
  constructor() {
    if (typeof window.videoPlayerManager !== 'undefined') {
      this.queuedPlayers = window.videoPlayerManager.queuedPlayers || [];
      this.queuedOutstreamPlayers =
        window.videoPlayerManager.queuedOutstreamPlayers || [];
      this.queuedAudioPlayers =
        window.videoPlayerManager.queuedAudioPlayers || [];
    } else {
      this.queuedPlayers = [];
      this.queuedOutstreamPlayers = [];
      this.queuedAudioPlayers = [];
    }
    this.supportsAutoplay = null; // Autoplay will only fire if this value is true
    this.checkIfAutoplayIsSupported();

    this.players = {};
    this.outstreamPlayers = {};
    this.audioPlayers = {};

    this.scripts = {};
    window.videoPlayerManager = this;
    this.queuedPlayers.forEach(player => {
      this.spawnPlayer(player);
    });
    this.queuedOutstreamPlayers.forEach(player => {
      this.spawnOutstreamPlayer(player);
    });
    this.queuedAudioPlayers.forEach(player => {
      this.spawnAudioPlayer(player);
    });
  }

  checkIfAutoplayIsSupported() {
    // TODO
    // First check to see if we've done this test before, and when the last test was.
    // If we have done a test in the past 48 hours, then just take that previous value
    // If we haven't, then do the test and store it in local

    this.supportsAutoplay = true;
    return; // Temporary Hacky fix. Just assume all devices support autoplay and fallback to a user agent check for now.

    const autoplayTestPlayer = document.createElement('video');
    const mp4 = document.createElement('source');
    mp4.src =
      'data:video/mp4;base64,AAAAFGZ0eXBNU05WAAACAE1TTlYAAAOUbW9vdgAAAGxtdmhkAAAAAM9ghv7PYIb+AAACWAAACu8AAQAAAQAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAgAAAnh0cmFrAAAAXHRraGQAAAAHz2CG/s9ghv4AAAABAAAAAAAACu8AAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAABAAAAAAAAAAAAAAAAAABAAAAAAFAAAAA4AAAAAAHgbWRpYQAAACBtZGhkAAAAAM9ghv7PYIb+AAALuAAANq8AAAAAAAAAIWhkbHIAAAAAbWhscnZpZGVBVlMgAAAAAAABAB4AAAABl21pbmYAAAAUdm1oZAAAAAAAAAAAAAAAAAAAACRkaW5mAAAAHGRyZWYAAAAAAAAAAQAAAAx1cmwgAAAAAQAAAVdzdGJsAAAAp3N0c2QAAAAAAAAAAQAAAJdhdmMxAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAFAAOABIAAAASAAAAAAAAAABAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAGP//AAAAEmNvbHJuY2xjAAEAAQABAAAAL2F2Y0MBTUAz/+EAGGdNQDOadCk/LgIgAAADACAAAAMA0eMGVAEABGjuPIAAAAAYc3R0cwAAAAAAAAABAAAADgAAA+gAAAAUc3RzcwAAAAAAAAABAAAAAQAAABxzdHNjAAAAAAAAAAEAAAABAAAADgAAAAEAAABMc3RzegAAAAAAAAAAAAAADgAAAE8AAAAOAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA0AAAANAAAADQAAAA4AAAAOAAAAFHN0Y28AAAAAAAAAAQAAA7AAAAA0dXVpZFVTTVQh0k/Ou4hpXPrJx0AAAAAcTVREVAABABIAAAAKVcQAAAAAAAEAAAAAAAAAqHV1aWRVU01UIdJPzruIaVz6ycdAAAAAkE1URFQABAAMAAAAC1XEAAACHAAeAAAABBXHAAEAQQBWAFMAIABNAGUAZABpAGEAAAAqAAAAASoOAAEAZABlAHQAZQBjAHQAXwBhAHUAdABvAHAAbABhAHkAAAAyAAAAA1XEAAEAMgAwADAANQBtAGUALwAwADcALwAwADYAMAA2ACAAMwA6ADUAOgAwAAABA21kYXQAAAAYZ01AM5p0KT8uAiAAAAMAIAAAAwDR4wZUAAAABGjuPIAAAAAnZYiAIAAR//eBLT+oL1eA2Nlb/edvwWZflzEVLlhlXtJvSAEGRA3ZAAAACkGaAQCyJ/8AFBAAAAAJQZoCATP/AOmBAAAACUGaAwGz/wDpgAAAAAlBmgQCM/8A6YEAAAAJQZoFArP/AOmBAAAACUGaBgMz/wDpgQAAAAlBmgcDs/8A6YEAAAAJQZoIBDP/AOmAAAAACUGaCQSz/wDpgAAAAAlBmgoFM/8A6YEAAAAJQZoLBbP/AOmAAAAACkGaDAYyJ/8AFBAAAAAKQZoNBrIv/4cMeQ==';
    autoplayTestPlayer.appendChild(mp4);
    autoplayTestPlayer.id = 'base64TestVideo';
    autoplayTestPlayer.autoplay = true;
    autoplayTestPlayer.muted = false;
    autoplayTestPlayer.style.position = 'fixed';
    autoplayTestPlayer.style.left = '5000px';
    document.getElementsByTagName('body')[0].appendChild(autoplayTestPlayer);

    const base64TestVideo = document.getElementById('base64TestVideo');
    setTimeout(() => {
      if (!base64TestVideo.paused) {
        this.supportsAutoplay = true;
      } else {
        this.supportsAutoplay = false;
      }
      document.getElementsByTagName('body')[0].removeChild(autoplayTestPlayer);
    }, 475);
  }

  spawnPlayer(options) {
    let identifier = options.containerID;
    identifier = identifier.replace('#', '');
    this.players[identifier] = new videoPlayer(options, this);
    console.log("SPAWNING PLAYER");
    // return this.players[identifier];
  }

  spawnOutstreamPlayer(options) {
    let identifier = options.containerID;
    identifier = identifier.replace('#', '');
    this.outstreamPlayers[identifier] = new outstreamVideoPlayer(options, this);
  }

  spawnAudioPlayer(options) {
    let identifier = options.containerID;
    identifier = identifier.replace('#', '');
    this.audioPlayers[identifier] = new audioOnlyPlayer(options, this);
    return this.audioPlayers[identifier];
  }

  destroyAllPlayers(outstream = false) {
    let playerIds = Object.keys(window.videoPlayerManager.players);
    if (outstream) {
      playerIds = Object.keys(window.videoPlayerManager.outstreamPlayers);
    }

    playerIds.forEach(playerId => {
      console.log(`DESTROYING - ${playerId}`);
      this.destroyPlayer(playerId, outstream);
    });
  }

  destroyPlayer(playerId, outstream = false) {
    let players = window.videoPlayerManager.players;
    if (outstream) {
      players = window.videoPlayerManager.outstreamPlayers;
    }

    if (typeof players[playerId] === 'undefined') return;

    players[playerId].allTechReadyGo = () => null;
    players[playerId].initialisePlayer = () => null;
    players[playerId].modifyAdserverUrlWithTargeting = () => null;
    players[playerId].modifyAdserverUrlWithIxWrapper = () => null;
    players[playerId].fetchVideos = () => null;
    players[playerId].fetchPlaylist = () => null;
    players[playerId].buildPlaylist = () => null;
    players[playerId].readyUpFrontend = () => null;
    players[playerId].buildUpNext = () => null;
    players[playerId].tickUpNext = () => null;
    if (players[playerId].upNextInterval) {
      clearInterval(players[playerId].upNextInterval);
    }
    players[playerId].callbackAllVideosFetched = () => null;
    if (players[playerId].autoplayInterval) {
      clearInterval(players[playerId].autoplayInterval);
    }
    window.removeEventListener('resize', players[playerId].resizeCallback);
    players[playerId].intersectionCallback = () => null;
    players[playerId].callbackAdsEnded = () => null;
    players[playerId].callbackPlay = () => null;
    players[playerId].callbackLoadMetadataFinished = () => null;
    if (
      players[playerId].observer &&
      typeof players[playerId].observer.disconnect === 'function'
    ) {
      players[playerId].observer.disconnect();
    }

    players[playerId].player.dispose();

    const selectorString = `#${playerId}__container-outermost`;
    const playerEl = document.querySelector(selectorString);
    if (playerEl) {
      playerEl.remove();
    } else {
      console.log(`${selectorString} does not exist`);
    }

    delete players[playerId];
  }

  stopAllPlayers() {
    this.players.forEach(player => {
      player.player.stop();
      player.player.ads.stop();
    });
  }

  stopAudioPlayers() {
    this.audioPlayers.forEach(player => {
      player.player.stop();
      player.player.ads.stop();
    });
  }

  // Checks to see if a registered player's container div is missing.
  // If so, remove the player, keeping all other players in action
  cleanUpMissingPlayers() {
    const playerIds = Object.keys(window.videoPlayerManager.players);
    playerIds.forEach(playerId => {
      const selectorString = `#${playerId}__container-outermost`;
      const playerEl = document.querySelector(selectorString);
      if (!playerEl) {
        window.videoPlayerManager.destroyPlayer(playerId);
      }
    });
  }

  // Checks whether a given video player has already been fetched
  isScriptFetched(identifier) {
    if (
      typeof (window.videoPlayerManager.scripts[identifier] !== 'undefined') &&
      window.videoPlayerManager.scripts[identifier] === true
    ) {
      return true;
    }
    return false;
  }

  fetchIMA3Script(callbackFunc) {
    let script = document.createElement('script');
    script.async = 1;
    script.onload = script.onreadystatechange = function(_, isAbort) {
      if (
        isAbort ||
        !script.readyState ||
        /loaded|complete/.test(script.readyState)
      ) {
        script.onload = script.onreadystatechange = null;
        script = undefined;

        if (!isAbort) {
          window.videoPlayerManager.scripts.ima3 = true;
          if (callbackFunc) {
            callbackFunc();
          }
        }
      }
    };

    script.src = `//players.brightcove.net/videojs-ima3/3/videojs.ima3.min.js`;
    document.head.appendChild(script);

    // Also pull in the CSS file
    const link = document.createElement('link');
    link.id = 'ima3-stylesheet';
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = '//players.brightcove.net/videojs-ima3/3/videojs.ima3.min.css';
    link.media = 'all';
    document.head.appendChild(link);
  }

  fetchIXScript(callbackFunc = false) {
    let script = document.createElement('script');
    script.async = 1;
    script.onload = script.onreadystatechange = function(_, isAbort) {
      if (
        isAbort ||
        !script.readyState ||
        /loaded|complete/.test(script.readyState)
      ) {
        script.onload = script.onreadystatechange = null;
        script = undefined;

        if (!isAbort) {
          window.videoPlayerManager.scripts.ix = true;
          if (callbackFunc) {
            callbackFunc();
          }
        }
      }
    };

    script.src = `//js-sec.indexww.com/htv/htv-dynamic.min.js`;
    document.head.appendChild(script);
  }

  // Fetch the Brightcove scripts necessary to get the player to render
  fetchBCScript(accountID, playerID, priorPromise = false) {
    const identifier = playerID + accountID;
    let script = document.createElement('script');
    script.async = 1;

    script.onload = script.onreadystatechange = function(_, isAbort) {
      if (
        isAbort ||
        !script.readyState ||
        /loaded|complete/.test(script.readyState)
      ) {
        script.onload = script.onreadystatechange = null;
        script = undefined;

        if (!isAbort) {
          window.videoPlayerManager.scripts[identifier] = true;
          if (priorPromise) {
            priorPromise();
          }
        }
      }
    };

    script.src = `//players.brightcove.net/${accountID}/${playerID}_default/index.min.js`;
    document.head.appendChild(script);
  }
}

export default () => new videoPlayerManager();
